import { render } from "./AddIdea.vue?vue&type=template&id=212049e0&scoped=true"
import script from "./AddIdea.vue?vue&type=script&lang=js"
export * from "./AddIdea.vue?vue&type=script&lang=js"

import "./AddIdea.vue?vue&type=style&index=0&id=212049e0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212049e0"]])

export default __exports__